import { render } from "./AppConfirmationDialogHOC.vue?vue&type=template&id=e6464ba0"
import script from "./AppConfirmationDialogHOC.vue?vue&type=script&lang=js"
export * from "./AppConfirmationDialogHOC.vue?vue&type=script&lang=js"
script.render = render

export default script